import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import config from '../../config';

export const VpStripeElementsWrapper = ({ stripeApiKey = config?.stripe.stripeKey, children }) => {
  const stripePromise = useMemo(() => loadStripe(stripeApiKey), [stripeApiKey]);

  return (
    <Elements
      options={{
        fonts: [
          {
            cssSrc: 'https://fonts.googleapis.com/css?family=Roboto:400&display=swap'
          }
        ]
      }}
      stripe={stripePromise}
    >
      {children}
    </Elements>
  );
};

VpStripeElementsWrapper.propTypes = {
  stripeApiKey: PropTypes.string,
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/vp-ui/wrappers/VpStripeElementsWrapper.jsx